<template>
  <div class="flex items-center gap-1">
    <div class="whitespace-nowrap font-semibold truncate">
      {{ event.title }}
    </div>
    <div
      :class="`timeline-event-tooltip timeline-event-tooltip-${event.id}`"
      :data-tippy-content="tooltipContent"
    >
      <InfoCircle class="w-3.5 h-3.5" :style="{ color: iconColor }" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { getComponentHtml } from "@/lib/getComponentHTML";

import InfoCircle from "@/images/info.svg?component";
import {
  Appointment,
  AppointmentEvent,
  TimelineEvent
} from "@/typings/scheduler";
import EventInfoTooltipContent from "./EventInfoTooltipContent.vue";

const props = defineProps<{
  event: TimelineEvent | AppointmentEvent;
  appointment: Appointment;
  iconColor: string;
}>();

const tooltipContent = computed(() => {
  return getComponentHtml(EventInfoTooltipContent, {
    event: props.event,
    appointment: props.appointment
  });
});
</script>

<style scoped></style>
